var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconCalendar = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M8.25 3C8.25 2.586 8.586 2.25 9 2.25C9.414 2.25 9.75 2.586 9.75 3V3.79275H14.25V3C14.25 2.586 14.586 2.25 15 2.25C15.414 2.25 15.75 2.586 15.75 3V3.79275H18.1875C19.7415 3.79275 21 5.04825 21 6.6V18.9427C21 20.4945 19.7415 21.75 18.1875 21.75H5.8125C4.2585 21.75 3 20.4945 3 18.9427V6.6C3 5.04825 4.2585 3.79275 5.8125 3.79275H8.25V3ZM14.25 5.29275H9.75V6C9.75 6.414 9.414 6.75 9 6.75C8.586 6.75 8.25 6.414 8.25 6V5.29275H5.8125C5.0865 5.29275 4.5 5.87775 4.5 6.6V9H19.5V6.6C19.5 5.87775 18.9135 5.29275 18.1875 5.29275H15.75V6C15.75 6.414 15.414 6.75 15 6.75C14.586 6.75 14.25 6.414 14.25 6V5.29275ZM4.5 10.5V18.9427C4.5 19.665 5.0865 20.25 5.8125 20.25H18.1875C18.9135 20.25 19.5 19.665 19.5 18.9427V10.5H4.5Z", fill: "black" }))),
        alt: 'Icon Calendar',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconCalendar;
//# sourceMappingURL=index.js.map